export const formInfo = [
    { name: "name", label: "Nombre", required: true },
    { name: "code", label: "Codigo", required: true }
];

export const tableInfo = [
    { key: "name", label: "Nombre" },
    { key: "code", label: "Codigo" }
];
